import { createContext, useContext, useState, ReactNode } from "react";

interface StripeInfo {
  publishableKey?: string;
  accountId?: string;
}

interface CheckoutSettingsInfo {
  tipping?: {
    enabled: boolean;
    amount1?: number;
    amount2?: number;
    amount3?: number;
  };
  colors?: {
    backgroundColor?: string;
    buttonColor?: string;
    accentColor?: string;
  };
  shippingZones?: Array<{
    name: string;
    countries: string[];
    prices: Array<{ name: string; price: number }>;
  }>;
  shippingProtection?: {
    enabled: boolean;
    price: number;
  };
  metaPixelId?: string;
}

interface PageContextType {
  page: any | null;
  stripe: StripeInfo | null;
  checkoutSettings: CheckoutSettingsInfo | null;
  setPage: (page: any | null) => void;
  setStripe: (stripe: StripeInfo | null) => void;
  setCheckoutSettings: (checkoutSettings: CheckoutSettingsInfo | null) => void;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

export function PageProvider({ children }: { children: ReactNode }) {
  const [page, setPage] = useState<any | null>(null);
  const [stripe, setStripe] = useState<StripeInfo | null>(null);
  const [checkoutSettings, setCheckoutSettings] = useState<CheckoutSettingsInfo | null>(null);

  return (
    <PageContext.Provider
      value={{
        page,
        stripe,
        checkoutSettings,
        setPage,
        setStripe,
        setCheckoutSettings,
      }}
    >
      {children}
    </PageContext.Provider>
  );
}

export function usePage() {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error("usePage must be used within a PageProvider");
  }
  return context;
}
